import { loadAppState } from './js/classes/core/AppState';
import { listen } from 'larasnap/echo';
import { Message, getUrlParam, moment } from 'larasnap/support';
import hooks from 'larasnap/hooks';

import {
    loadPanel,
    pageReady as runPageReadyHooks,
    getAppConfig,
    parseDomFull,
} from 'larasnap';

const jqueryIsLoaded = new Promise($);

const boot = async data => {
    if (!data) return;

    if (getAppConfig('debug')) {
        console.log('AppData', data);
    }

    syncContentWrapperHeight();

    listen('.SendMessage', ({ options }) => Message(options));

    await jqueryIsLoaded;

    loadAppState(data.state);
    parseDomFull();
    runPageReadyHooks();
    loadPanelFromQueryString();
    persistSidebarState();
};

const syncContentWrapperHeight = () => {
    const wrapper = $('.content-wrapper');
    if (!wrapper.length) return;

    new MutationObserver(() => {
        const height = wrapper.innerHeight();
        wrapper.children('section.content').innerHeight(height);
        hooks.run('wrapper-height-change', wrapper.innerHeight());
    }).observe(wrapper.get(0), {
        attributes: true,
    });

    const height = $('nav.main-header').outerHeight();
    wrapper
        .children('section.content')
        .css('height', `calc(100vh - ${height}px)`);
};

const loadPanelFromQueryString = () => {
    if (getUrlParam('loadPanel')) {
        loadPanel(getUrlParam('loadPanel'), getUrlParam('id'));
    }
};

const persistSidebarState = () => {
    $(document).on('collapsed.lte.pushmenu shown.lte.pushmenu', function () {
        const config = getAppConfig('sidebar_collapse');
        const isCollapsed = $('body').hasClass(config.css_class);
        const expires = moment().add(10, 'year').toDate();
        const key = config.cookie_name;
        const value = isCollapsed ? 'true' : 'false';
        const path = window.location.pathname;

        document.cookie = `${key}=${value}; expires=${expires}; path=/`;

        // Need to set this one too because sometimes there is a glitch and this cookie will
        // get added to the browser with a non-root path even though the root path is specified
        // above and then that cookie will override the one above. Adding another cookie with
        // the specific path should prevent that.
        document.cookie = `${key}=${value}; expires=${expires}; path=${path}`;
    });
};

export default boot;
